/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Legal_BasisInputs */

const en_impressum_legal_basis = /** @type {(inputs: Impressum_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal disclosure pursuant to DDG Section 5`)
};

const de_impressum_legal_basis = /** @type {(inputs: Impressum_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angaben gemaess SS 5 DDG`)
};

const fr_impressum_legal_basis = /** @type {(inputs: Impressum_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentions légales conformément au § 5 DDG`)
};

const es_impressum_legal_basis = /** @type {(inputs: Impressum_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información legal conforme al artículo 5 DDG`)
};

const it_impressum_legal_basis = /** @type {(inputs: Impressum_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informativa legale ai sensi del §5 DDG`)
};

const nl_impressum_legal_basis = /** @type {(inputs: Impressum_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wettelijke vermelding conform § 5 DDG`)
};

const pl_impressum_legal_basis = /** @type {(inputs: Impressum_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obowiązek informacyjny na podstawie § 5 DDG`)
};

const fi_impressum_legal_basis = /** @type {(inputs: Impressum_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lakisääteinen ilmoitus DDG:n 5 §:n mukaisesti`)
};

const da_impressum_legal_basis = /** @type {(inputs: Impressum_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juridisk oplysningspligt i henhold til DDG § 5`)
};

const sv_impressum_legal_basis = /** @type {(inputs: Impressum_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juridisk information enligt DDG 5 st.`)
};

/**
* | output |
* | --- |
* | "Legal disclosure pursuant to DDG Section 5" |
*
* @param {Impressum_Legal_BasisInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_legal_basis = /** @type {((inputs?: Impressum_Legal_BasisInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Legal_BasisInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_legal_basis(inputs)
	if (locale === "fr") return fr_impressum_legal_basis(inputs)
	if (locale === "es") return es_impressum_legal_basis(inputs)
	if (locale === "it") return it_impressum_legal_basis(inputs)
	if (locale === "nl") return nl_impressum_legal_basis(inputs)
	if (locale === "pl") return pl_impressum_legal_basis(inputs)
	if (locale === "fi") return fi_impressum_legal_basis(inputs)
	if (locale === "da") return da_impressum_legal_basis(inputs)
	if (locale === "sv") return sv_impressum_legal_basis(inputs)
	return en_impressum_legal_basis(inputs)
});